import React from 'react';

const Footer = () => {
  return (
    <footer 
      className="footer" 
      style={{ 
        backgroundColor: '#300885',
        padding: '15px 0',
        marginTop: 'auto'
      }}
    >
      <div className="container">
        <div className="text-center">
          <p style={{ 
            color: 'white', 
            margin: 0,
            fontSize: '14px'
          }}>
            &copy; 2024 Fathima Fashion, Tailoring App. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;